import React from 'react'
import { Nav, NavItem, NavLink } from 'reactstrap'
import { Link } from 'react-router-dom'

const loggedInNav = ({ toggleModal, onLogOut }) => (
  <Nav className="ml-auto" navbar>
    <NavItem>
      <NavLink
        to="/feedback"
        tag={Link}
        onClick={toggleModal}
      >
        Оставить отзыв
      </NavLink>
    </NavItem>
    <NavItem>
      <NavLink
        to="/settings"
        tag={Link}
      >
        Опции
      </NavLink>
    </NavItem>
    <NavItem>
      <NavLink
        to="/logout"
        tag={Link}
        onClick={onLogOut}
      >
        Выход
      </NavLink>
    </NavItem>
  </Nav>
)

export default loggedInNav



// WEBPACK FOOTER //
// ./src/components/nav/LoggedInNav.js